<template>
  <div>
    <add-service-item
      :openItem="false"
      :fieldsFrom="fields"
      :setLink="setLink"
      :cardLink="cardLink"
      :params="params"
      @input="$emit('input', item)"
    />
  </div>
</template>
<script>
import AddServiceItem from "../../Modals/AddServiceItem.vue";
export default {
  components: { AddServiceItem },
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["data"],
  data() {
    return {
      params: {},
      item: null,
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          label: "Номер телефона",
          key: "shop_id",
          type: "hidden",
          default: this.data.order.shop_id,
        },
        {
          label: "Номер телефона",
          key: "order_service_id",
          type: "hidden",
          default: this.data.id,
        },
        {
          label: "Номер телефона",
          key: "phone",
          labelKey: "phone",
          type: "mask",
          mask: "+998#########",
          default: this.data.order.client.phone,
        },
        {
          col: " col-12 col-md-6",
          label: "Имя клиента",
          key: "first_name",
          labelKey: "first_name",
          type: "field",
          default: this.data.order.client.first_name,
        },
        {
          col: " col-12 col-md-6",
          label: "Фамилия клиента",
          key: "last_name",
          labelKey: "last_name",
          type: "field",
          default: this.data.order.client.last_name,
        },
        {
          col: " col-12 col-md-6",
          label: "ПИНФЛ",
          key: "PINFL",
          labelKey: "PINFL",
          type: "field",
          default: this.data.order.client.PINFL,
        },

        {
          label: "Выберите товар с заказа",
          labelKey: "purchase_item",
          key: "purchase",
          type: "select",
          modal: "purchase",
          url: `orders/${this.data.order_id}/purchases`,
          selectKey: "name",
        },
        {
          label: "IMEI",
          key: "code",
          labelKey: "imei",
          type: "mask",
          mask: "###############",
        },
      ],

      /** APIs */
      removeLink: "",
      cardLink: "item_certificate",
      itemLink: "certificates",
      setLink: "certificates",
    };
  },
};
</script>
